import React from "react";
import { ArrowRight } from "lucide-react";

/**
 * variant: 'primary' | 'secondary-light' | 'secondary-dark'
 */
const Button = ({
  as: As = "button",
  variant = "primary",
  children,
  className = "",
  arrow = true,
  testId,
  ...rest
}) => {
  const variantClass =
    variant === "primary"
      ? "btn-primary"
      : variant === "secondary-light"
      ? "btn-secondary-light"
      : "btn-secondary-dark";

  return (
    <As className={`btn-os ${variantClass} ${className}`} data-testid={testId} {...rest}>
      <span>{children}</span>
      {arrow && (
        <span className="arrow" aria-hidden="true">
          <ArrowRight size={18} strokeWidth={2} />
        </span>
      )}
    </As>
  );
};

export default Button;
